<template>
  <div>
    <div
      class="badge"
      :class="'bg-'+getStatusColorVariant(statusValue)"
      @click.stop="editAllowed ? toggleStatusSelector() : null"
    >
      {{ getStatusString(statusValue) }}
    </div>
    <base-modal
      v-if="statusSelectorVisible && editAllowed"
      hide-footer
      :title="$t('calendar.change_order_status')"
      @close="statusSelectorVisible = false"
    >
      <div class="col-sm-12 nopads text-center">
        <div
          v-for="status in orderStatusArray"
          :key="status"
          class="col-sm-5 status-selector"
          :class="[    editAllowed ? 'pointer' : '',    'bg-' + getStatusColorVariant(status)  ]"
          @click.stop="changeStatus(status)"
        >
          {{ getStatusString(status ) }}
        </div>
      </div>
    </base-modal>
  </div>
</template>


<script>

import {workManagementHelper} from "@/components/mixins/WorkManagementMixin";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'OrderStatusBadge',
    components: {BaseModal},
    mixins: [workManagementHelper],
    props: {
        itemId: {
            type: Number,
            default: -1
        },
        status: {
            type: Number,
            default: -1
        },
        editAllowed: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            statusSelectorVisible: false,
            statusValue: -1
        }
    },
    watch: {
        status: function () {
            this.statusValue = this.status
        }
    },
    created() {
        this.statusValue = this.status
    },
    methods: {
        toggleStatusSelector() {
            if(this.editAllowed) {
                this.statusSelectorVisible = !this.statusSelectorVisible
            }
        },
        changeStatus(status) {
            this.$emit('orderStatusChanged', this.itemId, status)
            this.statusSelectorVisible = false
            this.statusValue = status
        }
    }
}
</script>
<style scoped>
.badge {
    font-size: .8em;
    font-weight: bold;
    text-align: center;
    border-radius: .3em;
    background: #404041;
    color: #000000;
    width: 6em;
    margin: auto;
    margin-top: 4px;
    margin-bottom: -4px;
    margin-left: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: uppercase;
    border: transparent 1px solid;
}

.badge:hover, .status-selector:hover {
    border: #BCBCBC 1px solid;
}

.status-selector {
    display: inline-block;
    text-align: center;
    font-weight: bold;
    color: #000000;
    margin: .3em;
    border-radius: 5px;
    font-size: .9em;
    border: transparent 1px solid;
}

.pointer {
    cursor: pointer;
}

</style>
